/* M-District v122: temporary offer countdown + popup (see snippets/md-promo.liquid). */
(function () {
  if (window.mdPromoInit) return;
  window.mdPromoInit = true;

  function store(kind) {
    try {
      return kind === 'local' ? window.localStorage : window.sessionStorage;
    } catch (e) {
      return null;
    }
  }
  function getFlag(kind, key) {
    var s = store(kind);
    try { return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function setFlag(kind, key) {
    var s = store(kind);
    try { if (s) s.setItem(key, '1'); } catch (e) { /* storage unavailable */ }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function format(left, units) {
    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;
    var out = (d > 0 ? d + units[0] + ' ' : '') + pad(h) + units[1] + ' ' + pad(m) + units[2] + ' ' + pad(s) + units[3];
    return out;
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var els = document.querySelectorAll('[data-md-promo]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = parseInt(el.getAttribute('data-end'), 10);
      var left = end - now;
      if (!end || left <= 0) {
        el.hidden = true;
        el.classList.remove('is-visible');
        continue;
      }
      var units = (el.getAttribute('data-units') || 'd,h,m,s').split(',');
      var t = el.querySelector('[data-md-promo-timer]');
      if (t) t.textContent = format(left, units);
    }
  }

  function bannerVisible() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && window.getComputedStyle(b).visibility !== 'hidden';
  }

  function initPopup() {
    var pop = document.querySelector('[data-md-promo-popup]');
    if (!pop) return;
    var key = pop.getAttribute('data-key') || 'md-promo';
    var end = parseInt(pop.getAttribute('data-end'), 10);
    if (!end || end <= Math.floor(Date.now() / 1000)) return;
    if (getFlag('local', key + '-dismissed')) return;
    if (getFlag('session', key + '-shown')) return;

    function close(remember) {
      pop.classList.remove('is-visible');
      window.setTimeout(function () { pop.hidden = true; }, 300);
      if (remember) setFlag('local', key + '-dismissed');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close(true);
    }

    var closeBtn = pop.querySelector('[data-md-promo-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
    var ctas = pop.querySelectorAll('[data-md-promo-cta]');
    for (var i = 0; i < ctas.length; i++) {
      ctas[i].addEventListener('click', function () { setFlag('local', key + '-dismissed'); });
    }

    var waited = 0;
    function show() {
      if (bannerVisible() && waited < 120) {
        waited += 1;
        window.setTimeout(show, 1000);
        return;
      }
      if (end <= Math.floor(Date.now() / 1000)) return;
      pop.hidden = false;
      setFlag('session', key + '-shown');
      document.addEventListener('keydown', onKey);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { pop.classList.add('is-visible'); });
      });
    }
    window.setTimeout(show, 5000);
  }

  function start() {
    tick();
    window.setInterval(tick, 1000);
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
